// ── DisputeBadge ──────────────────────────────────────────────────────────────

import type { Transaction } from "@/application/money/types";

interface DisputeBadgeProps {
  dispute: Transaction["dispute"];
}

export function DisputeBadge({ dispute }: DisputeBadgeProps) {
  if (dispute == null) return null;

  const tooltipText = dispute.status ?? "disputed";

  return (
    <span
      title={tooltipText}
      className="inline-flex items-center gap-1 rounded-full bg-red-100 px-2 py-0.5 text-xs font-medium text-red-700"
    >
      ⚠ Dispute
    </span>
  );
}
